export const searchDataNames = {
  state: 'state',
  city: 'city',
  product: 'product',
  mainSearch: 'mainSearch',
};
